export const jaTranslation = {
      common: {
        loading: "読み込み中",
        loadingWithDots: "読み込み中...",
        error: "エラーが発生しました",
        save: "保存",
        cancel: "キャンセル",
        search: "検索",
        logout: "ログアウト",
        close: "閉じる",
        back: "戻る",
        register: "登録",
        update: "更新",
        edit: "編集",
        delete: "削除",
        stop: "停止",
        restore: "復活",
        operation: "操作",
        downloadCsv: "CSVダウンロード",
        uploadCsv: "CSVアップロード",
        csvUploading: "CSVアップロード中...",
        uploading: "アップロード中...",
        processing: "処理中...",
        noData: "データなし",
        status: "状態",
        active: "有効",
        inactive: "無効",
        all: "すべて",
      },
      csvImportModal: {
        defaultButton: "CSVインポート",
        guideButton: "記載方法を見る",
        description: "テンプレートをダウンロードし、記載方法を確認してからCSVファイルを選択してください。",
        templateDownload: "テンプレートをダウンロード",
        selectAndImport: "CSVを選択してインポート",
        guideTitle: "記載方法",
        guideFetchFailed: "CSV記載方法を取得できませんでした。",
        guideFetchError: "CSV記載方法の取得に失敗しました。",
      },
      language: {
        japanese: "日本語",
        english: "英語",
        switchLabel: "表示言語",
      },
      auth: {
        loginTitle: "ログイン",
        email: "メールアドレス",
        password: "パスワード",
        loginNow: "ログイン",
        forgotPassword: "パスワードをお忘れですか？",
        emailRequired: "メールアドレスを入力してください。",
        emailInvalid: "メールアドレスの形式が正しくありません。",
        passwordRequired: "パスワードを入力してください。",
        invalidCredentials: "メールアドレスまたはパスワードが違います。",
        loginFailed: "ログインに失敗しました。",
      },
      navigation: {
        companyManagement: "企業管理",
        companyList: "企業一覧",
        itemList: "アイテム一覧",
        deviceManagement: "デバイス管理",
        nameMatchingManagement: "名寄せ管理",
        reportLayoutManagement: "帳票レイアウト管理",
        apiIntegration: "API連携",
        externalApiKeys: "外部連携APIキー",
        contractPlanManagement: "契約プラン管理",
        companyPlanAssignment: "企業プラン割当",
        backfill: "バックフィル",
        apiMonitoringDashboard: "API監視ダッシュボード",
      },
      externalApiKey: {
        title: "外部連携 APIキー管理",
        tabs: {
          keys: "キー一覧",
          events: "操作履歴",
        },
        keyCount: "APIキー数",
        issue: "APIキーを発行",
        issueOk: "発行する",
        rotate: "再発行",
        revoke: "失効",
        revoked: "失効",
        revokeFailed: "失効に失敗しました",
        revokeSucceeded: "APIキーを失効しました",
        rotateConfirmTitle: "APIキーを再発行しますか?",
        rotateConfirmContent: "「{{name}}」を再発行します。新しいキーを発行し、旧キーは 7 日間の猶予期間後に失効します。",
        planLimitReached: "プラン上限に達しています。Premium へのアップグレード、または企業のオーバーライド設定が必要です",
        issuedTitle: "APIキーを発行しました",
        fullKeyWarning: "このキーはこの画面でのみ表示されます。安全な経路で顧客に伝達してください (再表示不可)。",
        issuedNameHelp: "用途ラベル: {{name}}（コピー、またはCSVダウンロードで安全に保管してください）",
        revokeTitle: "APIキーを失効",
        revokeContent: "「{{name}}」を即時失効します。失効後このキーでの認証はできなくなります。",
        revokeReasonOptional: "失効理由 (任意)",
        validation: {
          nameRequired: "用途ラベル (name) は必須です",
        },
        columns: {
          name: "用途ラベル",
          keyPrefix: "キー prefix",
          expiresAt: "有効期限",
          lastUsedAt: "最終使用",
          createdAt: "作成日時",
          revokedAt: "失効日時",
        },
        filters: {
          activeOnly: "有効のみ",
          revokedOnly: "失効のみ",
        },
        fields: {
          nameRequired: "用途ラベル (name) *",
          expiresAtOptional: "有効期限 (任意)",
          allowedIpsOptional: "許可 IP (任意、カンマ区切り)",
        },
        placeholders: {
          name: "例: TSI本番",
          noExpiry: "無期限",
          allowedIps: "例: 203.0.113.0/24,198.51.100.42",
          revokeReason: "例: 顧客側で漏洩疑いのため",
        },
        events: {
          retentionNote: "操作履歴は監査目的で5年間保持されます。",
          noCompany: "企業を選択すると操作履歴を表示します。",
          apiKeyIdOptional: "APIキーID (任意)",
          apiKeyIdPlaceholder: "例: 12",
          eventTypeOptional: "種別 (任意)",
          fromOptional: "From (任意)",
          toOptional: "To (任意)",
          startDateTime: "開始日時",
          endDateTime: "終了日時",
          csvExport: "CSVエクスポート",
          csvExportFailed: "CSVエクスポートに失敗しました",
          csvDownloaded: "CSVをダウンロードしました",
          footerNote: "※ CSVエクスポートは現在のフィルタ条件でサーバ生成し、そのままダウンロードします。",
          columns: {
            occurredAt: "発生日時",
            type: "種別",
            key: "キー",
            keyPrefix: "キー prefix",
            actor: "操作者",
            reason: "理由",
          },
          types: {
            issued: "発行",
            rotated: "再発行",
            revoked: "失効",
            expires_extended: "有効期限延長",
            allowed_ips_changed: "許可IP変更",
          },
        },
      },
      contractPlan: {
        title: "契約プラン管理",
        propagationNote: "上限の変更は既存企業へ最大60秒で伝播します (キャッシュ反映のタイムラグがあります)。",
        listNote: "有効/無効すべてのプランを表示しています。",
        createButton: "プラン作成",
        createTitle: "契約プランを作成",
        editTitle: "契約プランを編集",
        editTitleWithCode: "契約プランを編集: {{code}}",
        createOk: "作成する",
        updateOk: "更新する",
        created: "契約プランを作成しました",
        updated: "契約プランを更新しました",
        deactivated: "契約プランを無効化しました",
        deactivate: "無効化",
        deactivateConfirmTitle: "「{{name}}」を無効化しますか?",
        deactivateConfirmContent: "無効化すると、このプランは新規の企業割当に使用できなくなります。すでにこのプランが割り当てられている企業には影響しません (実効上限はそのまま維持されます)。",
        editWarning: "この更新は全項目を上書きします。表示中の全フィールドを確認のうえ保存してください (省略した項目は既定値に戻ります)。",
        codeReadOnly: "code は変更できません。",
        allowed: "許可",
        notAllowed: "不可",
        fields: {
          code: "コード (code)",
          name: "プラン名 (name)",
          description: "説明 (任意)",
          rateLimitPerMinute: "レート上限/分",
          rateLimitPerHour: "レート上限/時",
          rateLimitImagePerMinute: "画像レート上限/分",
          maxPageSize: "最大ページサイズ",
          maxApiKeysPerCompany: "企業あたり最大APIキー数",
          maxRedeliveriesPerDay: "1日あたり最大再配信数",
          allowIpRestriction: "IP制限を許可",
        },
        validation: {
          codeRequired: "code は必須です",
          nameRequired: "name は必須です",
          required: "必須",
          max64: "64文字以内",
          max255: "255文字以内",
        },
        placeholders: {
          code: "例: premium",
          name: "例: プレミアムプラン",
          description: "プランの説明",
        },
        columns: {
          code: "コード",
          name: "プラン名",
          description: "説明",
          rateMinute: "レート/分",
          rateHour: "レート/時",
          imageRateMinute: "画像レート/分",
          maxApiKeys: "最大APIキー数",
          ipRestrictionAllowed: "IP制限許可",
        },
      },
      companyPlan: {
        title: "企業プラン割当",
        overrideNote: "オーバーライドは企業ごとの個別調整値です。空欄の項目はプランの値がそのまま使われます。",
        applySucceeded: "プランを適用しました",
        selectCompanyError: "企業を選択してください",
        selectPlanError: "適用するプランを選択してください",
        confirmTitle: "プランを適用しますか?",
        confirmContent: "選択企業に「{{planLabel}}」を適用します。レート上限・APIキー数などの実効上限が即座に変更され、顧客の利用に影響します。空欄のオーバーライドはプランの値が適用されます。よろしいですか?",
        currentAssignment: "現在の割当状況",
        assignedPlan: "割当プラン",
        unassigned: "未割当",
        effectiveLimits: "実効上限",
        planChangeTitle: "プラン変更 / オーバーライド設定",
        applyPlanRequired: "適用するプラン *",
        planSelectPlaceholder: "プランを選択",
        blankUsesPlanValue: "空欄=プラン値",
        usePlanValue: "プラン値を使用",
        apply: "適用",
        allowed: "許可",
        notAllowed: "不可",
        fields: {
          rateLimitPerMinute: "レート上限/分",
          rateLimitPerHour: "レート上限/時",
          rateLimitImagePerMinute: "画像レート上限/分",
          maxPageSize: "最大ページサイズ",
          maxApiKeysPerCompany: "企業あたり最大APIキー数",
          maxRedeliveriesPerDay: "1日あたり最大再配信数",
        },
      },
      backfill: {
        title: "バックフィル",
        description: "過去データを外部連携キュー (Webhook 等) に再投入します。投入後、進捗を自動更新します。",
        selectCompanyError: "企業を選択してください",
        selectApiKeyError: "対象APIキーを選択してください",
        submitted: "バックフィルを投入しました",
        labels: {
          company: "企業 *",
          apiKey: "対象APIキー *",
          from: "From (任意)",
          to: "To (任意)",
        },
        placeholders: {
          selectCompanyFirst: "先に企業を選択",
          selectApiKey: "APIキーを選択",
          startDateTime: "開始日時",
          endDateTime: "終了日時",
        },
        unsupportedNotice: "投入予定件数のプレビュー、レート (rate_per_minute) 指定、ジョブ中止は現状サーバ未対応です (#469 後続対応)。",
        submit: "バックフィルを投入",
        jobTitle: "投入ジョブ",
        job: {
          id: "ジョブID",
          total: "対象件数 (total)",
          enqueued: "投入済 (enqueued)",
          error: "エラー (error)",
          createdAt: "作成日時",
        },
        pollingMessage: "進捗を {{seconds}} 秒ごとに自動更新中…",
      },
      apiMonitoring: {
        title: "API監視ダッシュボード",
        deferredTitle: "提供範囲について",
        deferredNotice: "#457 集計バッチ未実装のため、以下は本画面では未対応です: 5分粒度 / 異常検知アラート (直近5分 N倍) / sample_id 追跡検索 / 企業横断フィルタ / 行レベル生ログ CSV。本画面は APIキー単位の hour/day 集計のみを表示します。",
        selectApiKeyWarning: "APIキーを選択してください",
        noStatsWarning: "エクスポート対象の統計がありません",
        placeholders: {
          selectApiKey: "APIキーを選択",
          selectCompanyFirst: "先に企業を選択",
          noActiveApiKeys: "有効なAPIキーがありません",
          startDate: "開始日付",
          endDate: "終了日付",
        },
        granularity: {
          hour: "1時間",
          day: "1日",
        },
        presets: {
          last24Hours: "直近24時間",
          last30Days: "直近30日",
        },
        show: "表示",
        csvExport: "CSV エクスポート",
        emptySelect: "企業と APIキーを選択すると統計を表示します",
        emptyNoData: "対象期間に統計データがありません",
        cards: {
          calls: "コール数推移",
          errorRate: "エラー率推移 ((4xx+5xx)/総数 %)",
          rateLimited: "レート制限ヒット数",
          statusBreakdown: "ステータスクラス別内訳 (積み上げ)",
        },
        series: {
          calls: "コール数",
          errorRate: "エラー率",
          rateLimited: "レート制限ヒット",
        },
        footerNote: "CSV は取得した集計値 (bucket × status_class) です。生ログ行ではありません (生ログ CSV は #457 未対応)。",
      },
      company: {
        companyInfo: "企業情報",
        detailPage: "企業詳細画面",
        companyName: "企業名",
        address: "住所",
        phoneNumber: "電話番号",
        phoneNumberNoHyphen: "電話番号 (ハイフン無し)",
        postCode: "郵便番号",
        postCodeNoHyphen: "郵便番号 (ハイフン無し)",
        toyoshimaSalesDepartment: "豊島営業部",
        toyoshimaSalesRepName: "豊島営業担当者名",
        plannedSite: "導入予定拠点",
        siteName: "拠点名",
        email: "メールアドレス",
        contactName: "担当者名",
        contactPosition: "担当者役職",
        contact: "窓口担当者",
        departmentName: "部署名",
        name: "氏名",
        position: "役職",
        billingInfo: "請求先情報",
        billingDepartment: "担当部署名",
        contractPeriod: "契約期間",
        contractInfo: "契約情報",
        startDate: "開始日",
        endDate: "終了予定日",
        amount: "販売金額",
        memo: "企業メモ",
        departmentMemo: "部署メモ",
        brandName: "ブランド名",
        selectCompany: "企業を選択",
        listPage: "企業一覧画面",
        registerPage: "企業登録画面",
        editPage: "企業編集画面",
        departmentRegister: "部署登録",
        departmentEdit: "部署編集",
        totalCount: "企業合計数: {{count}}件",
        registerCompanyDepartment: "企業・部署を登録",
        deleteTarget: "「{{name}}」を削除します。",
        deleteConfirm: "この操作は取り消せません。よろしいですか？",
        deleteOk: "削除する",
        departmentList: "部署一覧",
        departmentDetailPage: "部署詳細画面",
        departmentTotalCount: "部署合計数: {{count}}件",
        activeUserCount: "アクティブユーザー数: {{active}} / {{total}}",
        userList: "ユーザ一覧",
        addDepartment: "部署を追加",
        editCompanyDepartment: "企業・部署を編集",
        departmentCsvBulkRegister: "部署をCSV一括登録",
        userRegister: "ユーザ登録",
        userCsvBulkRegister: "ユーザCSV一括登録",
        measurementResults: "採寸結果一覧",
        deviceList: "デバイス一覧",
        measurementErrors: "設定誤差一覧",
        validation: {
          contactEmailRequired: "窓口担当者のメールアドレスを入力して下さい。",
          departmentRequired: "部署のブランド名と部署名を全て入力して下さい。",
          phoneNumberDigits: "電話番号はハイフン無し半角数字で入力して下さい",
          emailInvalid: "メールアドレスを確認して下さい。",
          postCodeDigits: "郵便番号は半角数字7桁で入力して下さい。",
        },
        messages: {
          duplicateDepartment: "同一企業内で部署名が重複しています。別の部署名を入力して下さい。",
          registerSucceeded: "企業の登録が完了しました。",
          updateSucceeded: "企業情報の更新が完了しました。",
          saveFailed: "企業情報の保存に失敗しました。",
        },
      },
      device: {
        listPage: "デバイス一覧画面",
        companyListPage: "{{companyName}}のデバイス一覧画面",
        registerPage: "デバイス登録画面",
        editPage: "デバイス編集画面",
        totalCount: "デバイス合計数: {{count}}件",
        registerNew: "デバイスを新規登録",
        registerNewShort: "デバイス新規登録",
        company: "企業",
        location: "拠点",
        deviceName: "デバイス名",
        apiKey: "API Key",
        initialSettings: "初期設定",
        createdDate: "登録日",
        updatedDate: "更新日",
        selectCompany: "企業を選択してください",
        deleteTarget: "{{name}}を削除します",
        deleteConfirmStrict: "この操作は元に戻せません。本当に実行しますか？",
        deleteSucceeded: "デバイスの削除が完了しました！",
        registerSucceeded: "デバイスを新規登録しました！",
        registerFailed: "デバイスの登録に失敗しました。",
        updateSucceeded: "デバイスの更新が完了しました!",
        updateFailed: "デバイスの更新に失敗しました。",
        requiredCompany: "企業を選択してください。",
        requiredLocationAndName: "拠点名とデバイス名は必須です。",
        regenerate: "再発行",
        regenerateConfirmTitle: "API Keyを再発行しますか？",
        regenerateConfirmContent: "現在のAPI Keyは直ちに使用できなくなります。",
        regenerateConfirmTitleWithContent: "API Keyを再発行すると現在のAPI Keyは直ちに使用できなくなります。",
        regenerateConfirmQuestion: "再発行しますか？",
        regenerateFailed: "API Keyの再発行に失敗しました。",
        regenerateSucceeded: "API Keyを再発行しました!",
        unsavedChangesTitle: "未保存の変更があります。",
        saveAndRegenerateConfirm: "変更を保存してAPI Keyを再発行しますか？",
        updateAndRegenerateSucceeded: "デバイス情報を更新し、API Keyを再発行しました。",
        updateInfoFailed: "デバイス情報の更新に失敗しました。",
      },
      itemMaster: {
        title: "アイテムマスター",
        listPage: "アイテムマスター一覧画面",
        companyListPage: "{{companyName}}のアイテムマスター一覧画面",
        janCode: "JANコード",
        repeat: "リピート",
        partNumber: "品番",
        sampleNumber: "サンプルNo",
        itemName: "アイテム名",
        brandName: "ブランド名",
        size: "サイズ",
        colorNo: "カラーNo",
        registerPage: "アイテムマスター登録画面",
        editPage: "アイテムマスター編集画面",
        janCodeMatchExact: "完全一致",
        janCodeMatchPrefix: "前方一致",
        targetCompanySelect: "対象企業を選択",
        required: "必須",
        companySelectDescription: "企業を選択すると、一覧・登録・CSV操作が有効になります。",
        selectCompany: "企業を選択",
        janCodeInput: "JANコードを入力",
        searchHelp: "検索方法に応じて、入力値と完全一致するJANコードまたは入力値から始まるJANコードを検索します。",
        partNumberSearchPlaceholder: "品番を部分一致で検索",
        itemNameSearchPlaceholder: "アイテム名を部分一致で検索",
        brandNameSearchPlaceholder: "ブランド名を部分一致で検索",
        clear: "クリア",
        totalCount: "アイテム合計数: {{count}}件",
        companyNotSelected: "対象企業が未選択です",
        selectCompanyToDisplayItems: "企業を選択するとアイテム一覧が表示されます。",
        registerItem: "アイテム登録",
        csvBulkRegister: "アイテムをCSV一括登録",
        showTotal: "全{{total}}件 {{start}}-{{end}}を表示",
        createdAt: "登録日時",
        updatedAt: "最終更新日時",
        deleteTarget: "「{{name}}」を削除します。",
        fallbackDeleteTarget: "対象アイテム",
        deleteConfirm: "この操作は取り消せません。よろしいですか？",
        deleteOk: "削除する",
        deleteSucceeded: "アイテムマスターを削除しました。",
        deleteFailed: "アイテムマスターの削除に失敗しました。",
        uploadSucceededWithCounts: "{{fileName}}のアップロードに成功しました。新規登録: {{created}}件 / 更新: {{updated}}件",
        companyIdMissing: "会社IDが取得できません。",
        companyIdLabel: "企業ID: {{id}}",
        csvRegistrationError: "CSV登録エラー",
        uploadFailed: "{{fileName}}のアップロードに失敗しました",
        validation: {
          janCodeDigitsOnly: "JANコードは半角数字のみで入力してください。",
          janCodeMaxLength: "JANコードは{{max}}桁以内で入力してください。",
          janCodeRequired: "JANコードを入力してください。",
          janCodeInvalidLength: "JANコードは8桁または13桁の数字で入力してください。",
          repeatNonNegativeInteger: "リピートは0以上の整数で入力してください。",
          partNumberRequired: "品番を入力してください。",
          partNumberMaxLength: "品番は{{max}}文字以内で入力してください。",
          sampleNumberMaxLength: "サンプルNoは{{max}}文字以内で入力してください。",
          itemNameRequired: "アイテム名を入力してください。",
          itemNameMaxLength: "アイテム名は{{max}}文字以内で入力してください。",
          brandNameRequired: "ブランド名を入力してください。",
          brandNameMaxLength: "ブランド名は{{max}}文字以内で入力してください。",
          sizeMaxLength: "サイズは{{max}}文字以内で入力してください。",
          colorNoRequired: "カラーNoを入力してください。",
          colorNoMaxLength: "カラーNoは{{max}}文字以内で入力してください。",
        },
        messages: {
          duplicateJanCode: "同一JANコードのアイテムマスターが既に存在します。",
          notFound: "対象のアイテムマスターが見つかりません。",
          registerFailed: "アイテムマスターの登録に失敗しました。",
          updateFailed: "アイテムマスターの更新に失敗しました。",
          registerSucceeded: "アイテムマスターを登録しました。",
          updateSucceeded: "アイテムマスターを更新しました。",
        },
      },
      messages: {
        registrationCompleted: "登録が完了しました",
        confirmInput: "入力内容を確認してください。",
        processFailed: "処理中にエラーが発生しました。",
        processFailedRetry: "処理中にエラーが発生しました。再度お試しください。",
        retry: "再度お試しください。",
        uploadSucceeded: "{{fileName}}のアップロードに成功しました",
        uploadFailed: "{{fileName}}のアップロードに失敗しました",
        csvDownloadFailed: "CSVのダウンロードに失敗しました。",
        csvUploadFailed: "CSVアップロードに失敗しました。",
      },
      errorCodes: {
        DEPARTMENT_NAME_DUPLICATED: "部署名がすでに存在します。",
        CONFLICT: "同じ内容のデータがすでに存在します。",
        VALIDATION_ERROR: "入力内容を確認してください。",
        RESOURCE_NOT_FOUND: "対象データが見つかりません。",
        INTERNAL_SERVER_ERROR: "処理中にエラーが発生しました。",
        AUTH_API_KEY_MISSING: "APIキーが指定されていません。",
        AUTH_INVALID_API_KEY: "APIキーが正しくありません。",
        AUTH_IP_NOT_ALLOWED: "このIPアドレスからのアクセスは許可されていません。",
        RATE_LIMIT_EXCEEDED: "アクセスが集中しています。時間をおいて再度お試しください。",
        PAYLOAD_TOO_LARGE: "送信データのサイズが上限を超えています。",
        URI_TOO_LONG: "URLが長すぎます。",
      },
      departmentUser: {
        registerPage: "ユーザ登録画面",
        editPage: "ユーザ編集画面",
        detailPage: "ユーザ詳細画面",
        adminRole: "管理者権限",
        pin: "PIN",
        maskedPassword: "●●●●●●●",
        createdDate: "登録日",
        lastLoginDate: "最終ログイン日",
        sampleStatsTitle: "ユーザ採寸型数",
        sampleCount: "{{count}}型",
        total: "合計",
        messages: {
          emailAlreadyRegistered: "メールアドレスがすでに登録されています。",
          authenticationFailed: "認証に失敗しました。",
          registerSucceeded: "ユーザー登録が完了しました。",
          updateSucceeded: "ユーザー情報の更新が完了しました。",
          genericError: "エラーが発生しました。",
        },
        reissue: {
          action: "再発行",
          confirmTitle: "本当に{{target}}を再発行しますか？",
          confirmContent: "再発行すると現在の{{target}}は無効になります。",
          pinSuccessTitle: "PINの再発行が完了しました。",
          pinSuccessContent: "新しいPINコードが保存されました。",
          pinErrorTitle: "PINの再発行に失敗しました。",
          passwordSuccessTitle: "パスワードの再発行が完了しました。",
          passwordSuccessContent: "新しいパスワードが保存されました。",
          passwordErrorTitle: "パスワードの再発行に失敗しました。",
        },
      },
      pages: {
        homeBack: "ホームに戻る",
        nameMatching: "名寄せ管理画面",
        measurementErrorList: "設定誤差一覧画面",
      },
      csvImportTitles: {
        nameCollation: "名寄せCSVインポート",
        departments: "部署CSVインポート",
        users: "ユーザーCSVインポート",
        measurementError: "ブランド別誤差CSVインポート",
        itemMaster: "アイテムマスターCSVインポート",
      },
      measurementError: {
        measurePoint: "採寸箇所",
        settingError: "設定誤差",
        plus: "プラス",
        minus: "マイナス",
      },
      reportLayout: {
        title: "採寸報告書レイアウト管理",
        csvImportTitle: "採寸報告書レイアウト管理CSVインポート",
        identifier: "識別（clothetype）",
        layoutType: "レイアウト種別（layout_type）",
        updatedAt: "更新日時",
        create: "新規登録",
        registerTitle: "レイアウト設定登録",
        editTitle: "レイアウト設定編集",
        bottomsLayout: "1: ボトムスレイアウト（左右配置）",
        topsLayout: "2: トップスレイアウト（上下配置）",
        otherLayout: "3: その他",
        fetchFailed: "採寸報告書レイアウトマスタを取得できませんでした。",
        saveFailed: "保存に失敗しました。",
        saveSucceeded: "保存しました。",
        deleteConfirmTitle: "削除確認",
        deleteConfirmContent: "{{name}} のレイアウト設定を削除します。",
        deleteFailed: "削除に失敗しました。",
        deleteSucceeded: "削除しました。",
        csvUploadSucceeded: "CSVを取り込みました。",
        csvErrors: {
          title: "CSV登録エラー",
          row: "{{rowNumber}}行目: {{message}}",
          uploadFailed: "{{fileName}}のアップロードに失敗しました。",
          codes: {
            HEADER_MISSING: "CSVヘッダーに必須カラムが不足しています。",
            HEADER_INVALID: "CSVヘッダーに使用できないカラムが含まれています。",
            EMPTY_DATA: "CSVにデータ行がありません。",
            MISSING_REQUIRED_FIELDS: "必須項目（clothtype、layout_type）を入力してください。",
            INVALID_CLOTHTYPE: "識別の種類（clothtype）が不正です。文字数や先頭文字を確認してください。",
            INVALID_LAYOUT_TYPE: "layout_typeは1、2、3のいずれかで指定してください。",
            DUPLICATE_CLOTHTYPE: "CSV内で識別の種類（clothtype）が重複しています。",
            CSV_INVALID_RECORD_LENGTH: "CSVの列数が行ごとに一致していません。",
            FILE_REQUIRED: "CSVファイルを選択してください。",
            FILE_EXTENSION_INVALID: "拡張子が.csvのファイルを選択してください。",
          },
        },
        validation: {
          identifierRequired: "識別を入力してください。",
          maxLength: "{{max}} 文字以内で入力してください。",
          noControlCharacters: "制御文字は使用できません。",
          noCsvFormulaPrefix: "先頭に =、+、-、@ は使用できません。",
          layoutTypeRequired: "レイアウト種別を選択してください。",
        },
      },
      measurements: {
        listPage: "{{companyName}}の採寸結果一覧画面",
        all: "すべて",
        filled: "入力済",
        unfilled: "未入力",
        notEntered: "未入力",
        selectedCount: "{{count}}件選択済み",
        clearSelection: "選択を解除",
        selectAll: "すべて選択",
        deleteSelected: "選択した項目を削除",
        exportSelectedCsv: "選択した項目をCSV出力",
        showTotal: "全{{total}}件 {{start}}-{{end}}を表示",
        thumbnail: "サムネイル",
        measuredAt: "採寸日時",
        openUrlNewTab: "URLを新しいタブで開く",
        recorder: "記録者",
        type: "タイプ",
        sample: "サンプル",
        final: "量産",
        measurement: "採寸",
        outputError: "出力エラー",
        invalidSelection: "有効なサンプルが選択されていません。",
        exportLimitExceeded: "一度にエクスポートできる採寸結果は{{count}}件です。",
        exportFailed: "CSV出力に失敗しました。",
        deleteFailedRetry: "削除に失敗しました。時間をおいて再度お試しください。",
        deleteReason: {
          label: "削除理由 (任意)",
          selectPlaceholder: "削除理由を選択",
          freeTextPlaceholder: "削除理由を入力 (任意)",
          presets: {
            顧客要望: "顧客要望",
            内部ミス削除: "内部ミス削除",
            データ不備: "データ不備",
            その他: "その他",
          },
        },
        deleteConfirmTitle: "削除確認",
        deleteOk: "削除する",
        bulkDeleteConfirm: "選択中の{{count}}件を削除します。削除すると元に戻せません。よろしいですか？",
        singleDeleteConfirm: "この採寸結果を削除します。削除すると元に戻せません。よろしいですか？",
      },
    } as const;
